import { UISpinner } from 'features/UI'
import { useAppDispatch } from 'hooks'
import { ReactNode, useEffect, useMemo } from 'react'
import { getQueryParams } from 'utils'
import {
  setFilterDistrict,
  setFilterSchool,
  setFilterSport,
  setFilterState,
} from '../../state/Init.reducer'
import {
  useGetDistrictsQuery,
  useGetSchoolByIdQuery,
  useGetSportsQuery,
  useGetStateByIdQuery,
} from '../../state/Init.rtk'
import * as Styled from './InitData.styled'

export function InitData({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch()

  const { state, district, school, sport } = getQueryParams()
  const { data: stateData, isLoading: isStateLoading } = useGetStateByIdQuery(state, {
    skip: !state,
  })

  const { data: districtData, isLoading: isDistrictsLoading } = useGetDistrictsQuery(state, {
    skip: !district,
  })

  const { data: schoolData, isLoading: isSchoolLoading } = useGetSchoolByIdQuery(school, {
    skip: !school,
  })

  const { data: sportsData, isLoading: isSportsLoading } = useGetSportsQuery(
    { sportId: sport },
    {
      skip: !sport,
    },
  )

  const isLoading = useMemo(() => {
    return isStateLoading || isDistrictsLoading || isSchoolLoading || isSportsLoading
  }, [isDistrictsLoading, isSportsLoading, isStateLoading, isSchoolLoading])

  useEffect(() => {
    if (!stateData) return

    dispatch(setFilterState(stateData))
  }, [dispatch, stateData])

  useEffect(() => {
    if (!districtData) return
    // find district by id from query param
    const districtValue = districtData.items.find((districtItem) => districtItem.id === district)
    dispatch(setFilterDistrict(districtValue || null))
  }, [dispatch, district, districtData])

  useEffect(() => {
    if (!schoolData) return

    dispatch(setFilterSchool(schoolData))
  }, [dispatch, schoolData])

  useEffect(() => {
    if (sportsData && sportsData.items) {
      // find sport by id from query param or get first sport
      const sportItem = sportsData.items.find((item) => item.id === sport)
      if (!sportItem) return

      dispatch(setFilterSport(sportItem))
    }
  }, [dispatch, sport, sportsData])

  if (!state || !district || !school || !sport) {
    return <Styled.ErrorTitle>Widget is not configured</Styled.ErrorTitle>
  }

  if (isLoading) {
    return <UISpinner />
  }

  return <>{children}</>
}
